export enum EMediaLoaderType {
  Chat = 'chat',
  Standalone = 'standalone',
  Lightbox = 'lightbox'
}

export enum EImageState {
  Load = 'load',
  Error = 'error'
}

export enum EVideoState {
  LoadedData = 'loadeddata',
  CanPlay = 'canplay',
  Error = 'error'
}
